const BOGOTA_TIME_ZONE = "America/Bogota";

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const getBogotaDateKey = (value) => {
  if (!value) return null;

  const stringValue = String(value).trim();

  if (DATE_ONLY_REGEX.test(stringValue)) {
    return stringValue;
  }

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: BOGOTA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const dateParts = Object.fromEntries(parts.filter(({ type }) => type !== "literal").map(({ type, value }) => [type, value]));

  return `${dateParts.year}-${dateParts.month}-${dateParts.day}`;
};

/**
 * Formatea una fecha para mostrarla al usuario.
 *
 * Ej:
 * "2026-10-11" -> "11 oct 2026"
 */
export const formatBogotaDate = (value) => {
  const dateKey = getBogotaDateKey(value);

  if (!dateKey) {
    return "Sin fecha";
  }

  const [year, month, day] = dateKey.split("-").map(Number);

  const safeDate = new Date(Date.UTC(year, month - 1, day, 12));

  return new Intl.DateTimeFormat("es-CO", {
    timeZone: BOGOTA_TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(safeDate);
};

export { BOGOTA_TIME_ZONE };
